var map = {
	"./camera.svg": 78039,
	"./ignore-add.svg": 44094,
	"./ignore-file-pdf.svg": 77758,
	"./ignore-file-word.svg": 68964,
	"./ignore-file-xlsx.svg": 61713,
	"./ignore-ope-delete.svg": 94131,
	"./ignore-time.svg": 19138,
	"./ignore-video-title.svg": 20707
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94551;